import ApiClient from "../../api-client";
import { API_URL } from "../../environment";

export const saveFilter = ({values, dispatch, token}) => {
    return ApiClient.post(`${API_URL}/patient/filter/save-filter`, values, token, dispatch);
};

export const deleteFilter = ({values, dispatch, token}) => {
    return ApiClient.delete(`${API_URL}/patient/filter/delete-filter`, values, token, dispatch);
};

